// "Glorified Fry Cooks" — first-person narrator break. Warm photo of Dan+Wella
// in a south St. Louis diner window.
// Version param breaks any cached HTML response this path may have served
// when the static file didn't yet exist. Bump on photo replacement.
const PHOTO_SRC = "/dan-wella.jpg?v=2";

export default function FryCooks() {
  return (
    <section
      id="fry-cooks"
      style={{
        background: "radial-gradient(ellipse 70% 80% at 0% 50%, rgba(239,83,126,0.16) 0%, transparent 55%), #133862",
        padding: "5rem 1.25rem",
      }}
    >
      <div style={{
        maxWidth: "1000px",
        margin: "0 auto",
        display: "grid",
        gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
        gap: "2rem",
        alignItems: "center",
      }}
      className="jop-frycooks-grid"
      >
        <div style={{
          aspectRatio: "3 / 2",
          borderRadius: "14px",
          overflow: "hidden",
          background: "#081a2a",
          boxShadow: "0 12px 36px rgba(0,0,0,0.35), 0 0 0 1px rgba(255,218,173,0.08)",
        }}>
          <img
            src={PHOTO_SRC}
            alt="Dan and Wella at the diner"
            style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
          />
        </div>

        <div>
          <h2 style={{
            margin: "0 0 1rem",
            fontFamily: "var(--jop-script)",
            fontSize: "clamp(1.8rem, 4.2vw, 2.8rem)",
            color: "var(--jop-gold)",
            fontWeight: 700,
            letterSpacing: "-0.01em",
          }}>
            Glorified Fry Cooks
          </h2>

          <div style={{
            color: "var(--jop-cream)",
            fontFamily: "var(--jop-display)",
            fontSize: "clamp(1rem, 2vw, 1.1rem)",
            lineHeight: 1.7,
          }}>
            <p style={{ margin: "0 0 0.9rem", fontStyle: "italic", color: "var(--jop-pink)", fontSize: "0.92rem", letterSpacing: "0.04em", fontWeight: 700, textShadow: "0 0 14px rgba(239,83,126,0.35)" }}>
              *record scratch*
            </p>
            <p style={{ margin: 0 }}>
              Before the Today Show and the world tour and all of it, Dan was pulling graveyard shifts at a diner in south St. Louis, drawing faces on pancakes for tips. He never really stopped. Wella joined the mission, brought the eye for design and the poffertjes, and now we're here. Making art people eat, for a living. We love it every single time.
            </p>
          </div>
        </div>
      </div>

      {/* Responsive: stack on mobile */}
      <style>{`
        @media (max-width: 720px) {
          .jop-frycooks-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
